module.exports = __webpack_public_path__ + "img/ps4.35ae2c59.jpg";